import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import './Header.css';

function Header({ activePage, setActivePage }) {
    return (
        <Navbar expand="lg" className="header-navbar">
            <Container fluid>
                <Navbar.Brand className="navbar-brand-custom">
                    <span className="brand-icon">🕉️</span>
                    <span className="brand-text">Goloka Dham</span>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ms-auto">
                        <Nav.Link
                            className={`nav-button ${activePage === 'home' ? 'active' : ''}`}
                            onClick={() => setActivePage('home')}
                        >
                            Home
                        </Nav.Link>
                        <Nav.Link
                            className={`nav-button ${activePage === 'quizzes' ? 'active' : ''}`}
                            onClick={() => setActivePage('quizzes')}
                        >
                            Quizzes
                        </Nav.Link>
                        <Nav.Link
                            className={`nav-button ${activePage === 'calendar' ? 'active' : ''}`}
                            onClick={() => setActivePage('calendar')}
                        >
                            Calendar
                        </Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default Header;
